import React, { useState } from "react";
import { Box, Icon, Tab, TabList, Tabs } from "@chakra-ui/react";
import { MdVisibility, MdReceiptLong, MdErrorOutline } from "react-icons/md";
import { StripeStateSection, HistorySection } from "./SubscriptionDetailSections";
import InvoicesList from "./InvoicesList";
import PaymentFailuresList from "./PaymentFailuresList";

const TABS = ["overview", "invoices", "failures"];

const tabProps = {
    color: "rgba(255, 255, 255, 0.55)",
    fontWeight: 600,
    fontSize: "0.75rem",
    minH: "36px",
    minW: 0,
    px: 3,
    gap: 1,
    _selected: { color: "#17dcb8", borderColor: "#17dcb8" },
};

/**
 * Renders the overview pane (Stripe state + history) used by the first tab.
 * @param {Object} props
 * @param {Object} props.detail - Normalized detail object
 * @returns {React.ReactElement}
 */
function OverviewPane({ detail }) {
    return (
        <>
            <StripeStateSection stripeState={detail.stripeState} />
            <HistorySection history={detail.history} />
        </>
    );
}

/**
 * Picks the right pane component based on the active tab.
 * @param {Object} props
 * @param {string} props.tab - Active tab key
 * @param {string|number} props.subscriptionId - Target subscription ID
 * @param {Object} props.detail - Normalized detail object
 * @returns {React.ReactElement}
 */
function ActivePane({ tab, subscriptionId, detail }) {
    if (tab === "invoices") return <InvoicesList subscriptionId={subscriptionId} />;
    if (tab === "failures") return <PaymentFailuresList subscriptionId={subscriptionId} />;
    return <OverviewPane detail={detail} />;
}

/**
 * Sub-tabs inside the detail drawer: Overview / Invoices / Payment failures.
 * @param {Object} props
 * @param {string|number} props.subscriptionId - Target subscription ID
 * @param {Object} props.detail - Normalized detail object
 * @returns {React.ReactElement}
 */
function DetailContentTabs({ subscriptionId, detail }) {
    const [tab, setTab] = useState("overview");
    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <Tabs index={TABS.indexOf(tab)} onChange={(i) => setTab(TABS[i])}
                variant="line" isFitted minH="36px">
                <TabList borderColor="rgba(255, 255, 255, 0.12)">
                    <Tab {...tabProps}><Icon as={MdVisibility} boxSize="16px" />Vue</Tab>
                    <Tab {...tabProps}><Icon as={MdReceiptLong} boxSize="16px" />Factures</Tab>
                    <Tab {...tabProps}><Icon as={MdErrorOutline} boxSize="16px" />Échecs</Tab>
                </TabList>
            </Tabs>
            <Box>
                <ActivePane tab={tab} subscriptionId={subscriptionId} detail={detail} />
            </Box>
        </Box>
    );
}

export default DetailContentTabs;
